import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import { MIN_PASSWORD_LENGTH } from '../constants/UserSettings';

const DEFAULT_ZIP_REGEXP = new RegExp(/^\s*$/);

// Used at login, old emails may contain special characters
export function isBasicValidEmail(email: string): boolean {
  if (typeof email !== 'string') {
    return false;
  }

  const re = new RegExp(/^.+@.+\..+$/);
  return re.test(email);
}

export function isValidEmail(email: string): boolean {
  if (typeof email !== 'string') {
    return false;
  }

  // cannot start or stop with a '.'
  const indexDot = email.indexOf('.');
  if (indexDot === -1 || indexDot === 0) {
    return false;
  }

  const re = new RegExp(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}../-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  );
  return re.test(email);
}

export function isValidPassword(password: string): boolean {
  return password?.length >= MIN_PASSWORD_LENGTH;
}

export function isValidZipForRegExp(zip: $TSFixMe, regExp: string | RegExp): boolean {
  try {
    /* guard against bad regexp */
    const regexp = new RegExp(regExp);
    return regexp.test(zip);
  } catch (e) {
    return DEFAULT_ZIP_REGEXP.test(zip);
  }
}

export function isValidBirthYear(year: string | number): boolean {
  if (isString(year) && year.search(/\D/) >= 0) {
    return false;
  }

  const sanitized = isNumber(year) ? year : parseInt(year, 10);
  const isInFuture = year > new Date().getFullYear();
  return !isInFuture && sanitized >= 1800 && sanitized < 9999;
}

export function isValidBirthDate(
  year: string | number,
  month: string | number,
  day: string | number,
): boolean {
  const y = isNumber(year) ? year : parseInt(year, 10);
  const m = isNumber(month) ? month : parseInt(month, 10);
  const d = isNumber(day) ? day : parseInt(day, 10);
  const birthDate = new Date(y, m - 1, d);
  const time = birthDate.getTime();
  return !isNaN(time) && birthDate.getDate() === d && birthDate.getMonth() === m - 1;
}
